<template>
  <v-dialog v-model="dialog" scrollable max-width="900px" ref="signatureDialog">
    <v-snackbar v-model="snackbar" top color="warning">
      We need your signature!
    </v-snackbar>

    <v-container class="pa-0">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card :loading="loading">
            <v-card-text>
              <v-expansion-panels accordian v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h3>Term and Conditions</h3>
                    <v-spacer></v-spacer>
                    <div style="max-width:100px" class="text-center">
                      <v-chip v-if="agreed" color="success">AGREED</v-chip>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <TermsAndConditions @terms-conditions-agreed="agreed = $event"/>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel :disabled="!agreed">
                  <v-expansion-panel-header>
                    <h3>Sign and submit</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-card>
                            <v-card-text :style="$vuetify.breakpoint.xsOnly ? 'padding:0' : ''">
                              <VueSignaturePad ref="signaturePad" :height="signatureHeight" width="100%" />
                            </v-card-text>
                            <v-card-actions :style="$vuetify.breakpoint.xsOnly ? 'padding:4px' : ''" v-if="agreed">
                              <v-row>
                                <v-col cols="3" offset="3">
                                  <v-btn block @click="clearSignature">Clear</v-btn>
                                </v-col>
                                <v-col cols="3">
                                  <v-btn block @click="dialog = false">Close</v-btn>
                                </v-col>
                                <v-col cols="3">
                                  <v-btn block @click="submit">Submit</v-btn>
                                </v-col>
                              </v-row>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
import TermsAndConditions from '@/components/tc'
import { Vue, Component, Watch } from 'vue-property-decorator'

@Component({
  components: {
    TermsAndConditions
  }
})
export default class SignatureDialog extends Vue {
  signatureHeight = '376px'
  dialog = false
  loading = false
  agreed = false
  panel = 0
  snackbar = false

  mounted () {
    this.signatureHeight = (
      this.$vuetify.breakpoint.mdAndUp ? '376px' : (
        this.$vuetify.breakpoint.xsOnly ? '160px' : '200px'
      )
    )
  }

  clearSignature () {
    this.$refs.signaturePad.clearSignature()
  }

  @Watch('agreed')
  onAgreed (val) {
    if (val) {
      this.panel = 1
    }
  }

  open () {
    this.dialog = true
  }

  close () {
    this.loading = false
    this.dialog = false
  }

  submit () {
    const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
    if (isEmpty) {
      this.snackbar = true
    }
    this.loading = true
    this.$emit('signed-and-submit', data)
  }
}
</script>
